import React from "react"

export default function Footer(){
    return(

        <footer class="foot-sec text-gray-600 body-font">
          <div class="container px-5 py-8 mx-auto flex items-center sm:flex-row flex-col">
            <a class="flex title-font font-medium items-center md:justify-start justify-center text-gray-900" href="/">
              <span class="foot-log ml-3 text-purple-700">WALOBWA</span>
            </a>
            <p class="text-sm text-gray-500 sm:ml-4 sm:pl-4 sm:border-l-2 sm:border-gray-200 sm:py-2 sm:mt-0 mt-4">COPYRIGHT | © 2023 Walobwa Dan —
            </p>
            <span class="inline-flex sm:ml-auto sm:mt-0 mt-4 justify-center sm:justify-start">
              <a target="_blank" href="https://github.com/WalobwaD"><i className="fa-brands fa-bounce px-3 text-3xl fa-github text-gray-700"></i></a>
              <a target="_blank" href="https://twitter.com/WalobwaDan"><i className="fa-brands fa-bounce px-3 text-3xl fa-twitter fa-github text-blue-700"></i></a>
              <a target="_blank" href="https://www.instagram.com/d.antteee/"><i className="fa-brands fa-bounce px-3 text-3xl fa-instagram text-pink-900"></i></a>
              <a target="_blank" href="/"><i className="fa-brands fa-bounce px-3 text-3xl fa-slack text-red-700"></i></a>
              <a target="_blank" href="https://www.linkedin.com/in/dan-walobwa-a1bba0212/"><i className="fa-brands fa-bounce px-3 text-3xl fa-linkedin text-blue-700"></i></a>
            </span>
          </div>
        </footer>
    )
}